<template>
  <div class="proposal-user-info__controls">
    <el-button
      type="primary"
      class="r-button"
      size="mini"
      @click="clickHandler('cancel')"
      v-if="hasChanges"
    >
      {{ $t("cancel") }}
    </el-button>
    <el-button
      type="success"
      class="r-button"
      size="mini"
      @click="clickHandler('accept')"
      v-if="!acceptDisabled"
    >
      {{ $t("accept") }}
    </el-button>
    <el-button
      type="danger"
      class="r-button"
      size="mini"
      @click="clickHandler('reject')"
      v-if="!rejectDisabled"
    >
      {{ $t("reject") }}
    </el-button>
    <el-button
      type="primary"
      class="r-button"
      size="mini"
      @click="goToUser()"
      v-if="proposal && proposal.accepted"
    >
      {{ $t("go-to-user") }}
    </el-button>
  </div>
</template>

<script>
export default {
  props: {
    proposal: {
      type: Object,
      required: true,
      default: () => null
    }
  },
  computed: {
    hasChanges() {
      return this.$store.state.proposal.hasChanges;
    },
    acceptDisabled() {
      return this.proposal && this.proposal.accepted;
    },
    rejectDisabled() {
      return (
        this.proposal && (this.proposal.accepted || this.proposal.rejected)
      );
    }
  },
  methods: {
    clickHandler(action) {
      this.$emit("before-action", action);
    },
    goToUser() {
      this.$router.push({
        path: `/app/user-roles?id=${this.proposal.user_id}`
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.proposal-user-info__controls {
  position: relative;
}
</style>

<i18n>
{
  "ru": {
    "cancel": "Отменить изменения",
    "accept": "Принять",
    "reject": "Отклонить",
    "go-to-user": "Перейти к редактированию"
  },
  "en": {
    "cancel": "Cancel changes",
    "accept": "Accept",
    "reject": "Reject",
    "go-to-user": "Go to edit"
  }
}
</i18n>
